import { Component, OnInit, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { Http } from '@angular/http';
import { NotificationService } from 'src/app/shared/notification.service';
import { ApiService } from 'src/app/shared/api.service';
import { Headers, RequestOptions } from '@angular/http';
import { PanelMemberService } from 'src/app/shared/panel-member.service';
import { GlobalConstantsService } from 'src/app/shared/global-constants.service';

@Component({
  selector: 'app-upload-excel',
  templateUrl: './upload-excel.component.html',
  styleUrls: ['./upload-excel.component.scss']
})
export class UploadExcelComponent implements OnInit {
  fetchPanelMembers = new EventEmitter();
  
  constructor(private http: Http,
    private panelMemberService: PanelMemberService,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<UploadExcelComponent>,
    private apiService: ApiService) { }

  ngOnInit() {
  }
  
  isSingleUploaded = false;
  private apiDomain = ApiService.getDomainName();
  private eventId = this.apiService.getEventId();

  onClose() {
    this.dialogRef.close();
  }
  csvInputChange(files) {
    // var files = fileInputEvent.target.files; // FileList object
    if(!(files[0].name.indexOf(".xlsx") > 0)){
      this.notificationService.warn('Only .xlsx & .xls extensions file can be acceptable');
      return false;
    }
    this.parseExcel(files[0]);
  }

  parseExcel(file) {
    console.log(file.name);
    this.isSingleUploaded = false;
    var reader = new FileReader();
    reader.onload = (e) => {
      var data = (<any>e.target).result;
      var workbook = XLSX.read(data, {
        type: 'binary'
      });
      workbook.SheetNames.forEach((function (sheetName) {
        // Here is your object
        var XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { raw: false });
        // var json_object = JSON.stringify(XL_row_object);

        if (XL_row_object &&
          Array.isArray(XL_row_object) &&
          (XL_row_object.length > 0)
        ) {
          // console.log(XL_row_object)
          const panelMemberXLVariableObjectList: Array<JSON> | null = GlobalConstantsService.XLTitleVariableMapper(XL_row_object, 'PANEL-MEMBER');
  
          this.panelMemberService.createPanelMember(panelMemberXLVariableObjectList).then(
            res => {
              this.notificationService.success((res && res.data && res.data.message) || 'File uploaded Successfully');
              this.fetchPanelMembers.emit(true);
            },
            err => {
              try {
                if(err && err.errors && Array.isArray(err.errors)) {
                  const errorList = err.errors;
                  errorList.forEach(errorObj => {
                    this.notificationService.warn(errorObj.message); 
                  });
                }
                this.fetchPanelMembers.emit(true);
              } catch (error) {
                switch(typeof err) {
                  case 'string': {
                    this.notificationService.warn(err);
                    break;
                  }
                  case 'object': {
                    if (err &&
                        err.errors &&
                        Array.isArray(err.errors)) {
                          // err.errors.forEach(msg => this.notificationService.warn(msg && msg.message));
                          this.notificationService.warn('Failed Due to Improper File Format');                        
                        }
                    break;
                  }
                  default: {
                    this.notificationService.warn('Failed to update');
                  }
                }
              }
              return false;
            }
          );
        } else {
          console.debug(XL_row_object);
          this.notificationService.warn('XLSX format is not proper.');
        }

        //this.gridObj.dataSource = JSON.parse(json_object);
      }).bind(this), this);
    }

    reader.onerror = function (ex) {
      console.log(ex);
    }
    reader.readAsBinaryString(file);
    console.log
  }

  createPanelMember(json_object) {
    let panelHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.post(this.apiDomain + "/ims/api/" + this.eventId + "/panelMember/", json_object, { headers: panelHeaders })
      .toPromise()
      .then(response => response as any)
      .catch(this.handleError);
  }

  private handleError(error: any) {
    console.error('An error occurred', error);
    try {
       const errorJSON = error && error.json();
      if ( errorJSON.httpCode == 401 ) {
        ApiService.sessionExpireRedirection();
      }
      return Promise.reject(errorJSON);
    } catch(err) {
      return Promise.reject(error && error.message);
    }
  }
}